export default  {
    namespaced: true,
    state: () => ({ 
        layout: 'app',
        is_show_sidebar: true,
        is_show_search: false,
        is_dark_mode: false,
     }),
    mutations: {  },
    actions: {  },
    getters: {  }
  }
